<template>
  <div class="container">
    <div class="header">
      <div class="left">共 {{ fileList.length }} 首（{{ totalSize }}）</div>
      <div class="right">
        <span @click="handleCheckAllChange(true)">全选</span>
        <span @click="handleCheckAllChange(false)">取消全选</span>
        <span @click="handleDeleteAll">删除全部</span>
      </div>
    </div>
    <div class="content">
      <div class="item-box item-add">
        <div class="add-box" @click="handleAddResource">
          <i style="font-size: 30px; color: #999999" class="el-icon-plus"></i>
        </div>
      </div>
      <div class="item-box" v-for="(item, index) in fileList" :key="item.uid">
        <el-checkbox
          @change="handleChange(item)"
          class="check-box"
          v-model="item.checked"
        ></el-checkbox>
        <div class="imgBox" @click="handlePlayAudio(item, index)">
          <img src="@/assets/images/upload/audioIcon.png" alt="" />
          <img
            v-if="!item.isPlaying"
            class="icon"
            src="@/assets/images/upload/playIcon.png"
            alt=""
          />
          <img
            v-else
            class="icon"
            src="@/assets/images/upload/pauseIcon.png"
            alt=""
          />
          <audio ref="audioRef" :src="item.url"></audio>
        </div>
        <div class="title">
          <div>
            {{ item.label }}
          </div>
          <div class="line" :class="item.isPlaying ? 'wave-animation' : ''">
            <img src="@/assets/images/upload/audioLine.png" alt="" />
          </div>
        </div>
        <div class="desc">
          {{ formatSecondsToHMS(item.duration) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "audioList",
  props: {
    uploadFileList: {
      type: Array,
      default: () => [],
    },
    registerType: {
      type: String,
      default: "0",
    },
  },
  watch: {
    uploadFileList: {
      handler() {
        this.fileList = this.uploadFileList.map((item, index) => {
          return {
            label: item.workFileName,
            url: item.url,
            checked: index == 0,
            uid: Math.random().toString(16).slice(2),
            isPlaying: false,
            workFileSize: item.workFileSize,
            duration: item.duration,
            workFileName: item.workFileName,
          };
        });
        this.$nextTick(() => {
          this.getAudioElement();
        });
      },
      deep: true,
    },
    registerType: {
      handler(val) {
        console.log(`val----`, val);
        if (val == 1) {
          if (!this.fileList.length) return;
          this.fileList.forEach((item, index) => {
            item.checked = index == 0;
          });
        }
      },
    },
  },
  data() {
    return {
      fileList: [],
      currentIndex: 0,
    };
  },
  computed: {
    totalSize() {
      let size = 0;
      this.fileList.forEach((item) => {
        size += item.workFileSize;
      });
      let value = Math.floor((size / 1024 / 1024) * 100) / 100;
      return value + " MB";
    },
  },
  methods: {
    handleChange(item) {
      if (this.registerType == "1") {
        const checkedList = this.fileList.filter((item) => item.checked);
        if (checkedList.length > 1) {
          this.$message.error("已登记作品不支持多选");
          item.checked = false;
          return;
        }
      }
    },
    getFileList() {
      return this.fileList;
    },
    upDateFileList() {
      this.fileList = this.fileList.filter((item) => !item.checked);
    },
    handleCheckAllChange(flag) {
      if (this.registerType == 1) {
        this.$message.error("已登记作品不支持多选");
        return;
      }
      this.fileList.forEach((item) => {
        item.checked = flag;
      });
    },
    handleDeleteAll() {
      this.fileList = [];
      this.$emit("clearAll");
    },
    handlePlayAudio(item, index) {
      this.currentIndex = index;
      console.log("this.$refs.audioRef", this.$refs.audioRef);
      this.fileList.forEach((el, i) => {
        if (el.uid == item.uid) {
          el.isPlaying = !el.isPlaying;
          if (el.isPlaying) {
            this.$refs.audioRef[i].play();
          } else {
            this.$refs.audioRef[i].pause();
          }
        } else {
          el.isPlaying = false;
          this.$refs.audioRef[i].pause();
        }
      });
    },
    stopAudio() {
      this.fileList[this.currentIndex].isPlaying = false;
    },
    // 获取音频元素
    getAudioElement() {
      const audioElements = this.$refs.audioRef;
      if (!audioElements) return;
      audioElements.forEach((el) => {
        el.addEventListener("ended", this.stopAudio);
      });
    },
    formatSecondsToHMS(seconds) {
      if (!seconds) return;
      // 计算时分秒
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = Math.floor(seconds % 60);

      // 补零格式化
      return [
        hours.toString().padStart(2, "0"),
        minutes.toString().padStart(2, "0"),
        remainingSeconds.toString().padStart(2, "0"),
      ].join(":");
    },
    handleAddResource() {
      this.$emit("uploadResource");
    },
  },
  beforeDestroy() {
    if (this.$refs.audioRef) {
      this.$refs.audioRef.forEach((el) => {
        el.pause();
        el.removeEventListener("ended", this.stopAudio);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    font-weight: 400;
    font-size: 14px;

    .left {
      color: #999999;
      font-size: 12px;
    }

    .right {
      color: #4e89ff;

      span {
        margin-right: 10px;
        cursor: pointer;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  border-radius: 4px;
  margin-bottom: 20px;
  border: 1px solid #e6e6e6;
  .add-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px dashed #409eff;
    border-radius: 10px;
  }
  .item-box {
    margin-bottom: 10px;
    height: 80px;
    padding: 5px;
    // background: #F6F9FF;
    border-radius: 3px;
    // border: 1px solid #F6F9FF;
    display: flex;
    align-items: center;

    &:last-child {
      margin-right: 0;
    }

    .check-box {
      margin-right: 3px;
      margin-left: 1px;
    }

    .imgBox {
      width: 80px;
      height: 80px;
      cursor: pointer;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .icon {
        width: 22px;
        height: 20px;
        position: absolute;
        bottom: 10px;
        right: 10px;
      }
    }

    .title {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      margin-left: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .line {
        margin-top: 10px;
      }
    }

    .desc {
      align-self: flex-end;
      margin-left: auto;
      margin-right: 20px;
    }
  }
}

.wave-animation {
  animation: wave 5s infinite linear;

  img {
    opacity: 0.8;
  }
}

@keyframes wave {
  0% {
    transform: scaleY(1);
  }

  25% {
    transform: scaleY(0.5);
  }

  50% {
    transform: scaleY(1);
  }

  75% {
    transform: scaleY(0.5);
  }

  100% {
    transform: scaleY(1);
  }
}
</style>
